import { render, staticRenderFns } from "./le-price-edit.vue?vue&type=template&id=46bc2166&scoped=true&"
import script from "./le-price-edit.vue?vue&type=script&lang=js&"
export * from "./le-price-edit.vue?vue&type=script&lang=js&"
import style0 from "./le-price-edit.vue?vue&type=style&index=0&id=46bc2166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bc2166",
  null
  
)

export default component.exports